<template>
  <div class="">
    <div id="container" class="xiexinChangePowerMap"></div>

    <div class="search-box flex align-center justify-center">
      <van-icon name="arrow-left" class="back-icon" @click="goBack()" v-if="this.isApp == 4"/>
    	<div class="search flex justify-between align-center">
        <input :focus="true" @blur="InputBlur" @confirm="inputConfirm" :adjust-position="false" type="text"
          placeholder-class="search-pla" placeholder="请输入换电站名称、地址" confirm-type="search" v-model="searchValue"></input>
    		<img src="https://sass.gclme.com/api/file/Image/annex/20220105_09247b22879142e98d3ff8e32cf67029.png" class="search-img" />
      </div>
      <div class="history">
        <div v-show="isGetList">
          <div class="flex justify-between align-center text-lg text-black margin-bottom-xl margin-top-xl">
            “{{searchValue}}”的搜索结果
          </div>
          <div class="history-list" v-for="(item,index) in searchList" :key="index"
            @click="chooseStation(item)" v-if="item.stationName || item.name">
            <div class="detail-type">
              <span>{{item.stationName ? item.stationName : item.name}}</span>
              <span>{{item.detailedAddress}}</span>
            </div>
            <!-- <van-icon name="guide-o" class="text-icon" /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索 -->
    <van-action-sheet
      v-model="sheetShow"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
    />
    <!-- 搜索 -->
    <div class="list-wrap" v-if="stationAllList.length > 0">
      <!-- interval="8000"   next-margin="15px" previous-margin="25px" :current="curIndex" -->
      <van-swipe @change="swiperChange" :show-indicators="false" duration="1000">
        <van-swipe-item v-for="(item,index) in stationAllList" v-if="item.businessStatus != 6 "  :key="index" class="swip-item"  >
          <div class="container-list flex" :class="(item.businessStatus==7 && item.officialBusinessStatus == 2 && !item.time) || item.businessStatus==7 && item.officialBusinessStatus == 0 && !item.time || (item.businessStatus==7 && item.officialBusinessStatus == 2) ? 'opcity' : ''">
          	<div class="list-left" @click="goUniapp('detail',item)">
              <!-- 暂停营业 -->
          		<img v-if="(item.businessStatus==7 && item.officialBusinessStatus == 2 && !item.time) || item.businessStatus==7 && item.officialBusinessStatus == 0 && !item.time || (item.businessStatus==7 && item.officialBusinessStatus == 2)"
          			class="stop-image" src="https://sass.gclme.com/api/file/Image/annex/20220105_5aed08f23808443890c85a050b832e0f.png" />
          		<img class="list-left-image"
          		  :src="item.stationImg&&item.stationImg.url ? IMAGE_URL + item.stationImg.url: 'https://sass.gclme.com/api/file/Image/annex/20220617_3277ab66521746989bf77368668cae85.png'" />
          		<div class="list-left-icon flex justify-center" v-if="index == 0 || index == 1 || index == 2">
          			T<div>{{index + 1}}</div>
          		</div>
              <div class="busy-status" v-if="item.businessStatus == '4'">
                <img class="staus-bg"
                  src="https://sass.gclme.com/api/file/Image/annex/20220105_ea0218706f1e41e9b23b7793e1dad8da.png" alt="">
                <div>试运营</div>
              </div>
          		<div class="busy-status"   v-if="item.businessStatus == '5' || item.businessStatus == '3'">
          			<img class="staus-bg"
          				src="https://sass.gclme.com/api/file/Image/annex/20220105_ea0218706f1e41e9b23b7793e1dad8da.png" />
          			<div >建设中</div>
          		</div>
          		<div class="busy-status" v-if="item.isBusy&&item.time!==false">
          			<img class="staus-bg" v-if="item.isBusy == 1"
          				src="https://sass.gclme.com/api/file/Image/annex/20220105_d11d318175d3473eb03d2da68880b423.png" />
          			<img class="staus-bg" v-if="item.isBusy == 0"
          				src="https://sass.gclme.com/api/file/Image/annex/20220105_af99dc97fc804ac09608a367afdc4065.png" />
          			<div v-if="item.isBusy == 0">空闲中</div>
          			<div v-if="item.isBusy == 1">繁忙中</div>
          		</div>
          	</div>
          	<div class="list-right flex" @click="goUniapp('detail',item)">
          		<div class="flex justify-between align-center">
          			<div class="title">{{item.stationName ? item.stationName : item.name}}</div>
          		</div>
          		<div class="right-contan flex" v-if="item.availableGan">
          			<div class="cu-newitem">
          				<div>{{item.type == '0e1f49d1b90c4036989d3545ec8d0966' ? '直流快充' : '交流慢充'}}</div>
          			</div>
          		</div>
              <div class="right-contan flex" v-else>
              	<div class="cu-newitem" v-if="item.businessStatus=='6'&&item.time!==false">
              		<text>24小时营业</text>
              	</div>
              	<div class="cu-newitem" v-if="item.stationType">
              		{{item.stationType}}专用
              	</div>
              	<div class="cu-newitem">
              		{{item.parkingChargeInformation?item.parkingChargeInformation:'停车免费'}}
              	</div>
              </div>
          		<div class="right-bottom flex">
          			<div class="bottom-change">
                  <div class="can-change flex justify-center" v-if="item.availableGan">
                  	<img class="home-icon margin-right-xs" src="https://sass.gclme.com/api/file/Image/annex/20220719_e9deb7f64c8e41fdb8a65dbf1fa81f62.png"  />
                  	{{item.availableGan?item.availableGan:'0'}}可充
                  </div>
          				<div class="can-change flex justify-center" v-else>
          					<img v-if="item.replaceableBattery>3" class="home-icon margin-right-xs"
          						mode="heightFix" src="https://sass.gclme.com/api/file/Image/annex/20220708_537f233607e64d66973da249ca305857.png" />
          					<img class="home-icon margin-right-xs"
          						v-if="item.replaceableBattery>=1&&item.replaceableBattery<=3"
          						src="https://sass.gclme.com/api/file/Image/annex/20220105_df06c4c61fd74d129f91f41356773a59.png" />
          					<img class="home-icon margin-right-xs" v-if="item.replaceableBattery==0"
          						src="https://sass.gclme.com/api/file/Image/annex/20220105_f1f6cbb502a44b9a8eb532c646e4b1a3.png"  />
          					{{item.replaceableBattery?item.replaceableBattery:'0'}}可换
          				</div>
          				<div class="wait-change flex justify-center margin-right" v-if="!item.availableGan">
          					<img class="home-icon margin-right-xs" mode="heightFix"
          						src="https://sass.gclme.com/api/file/Image/annex/20220708_dd70a7cb01ba41969c94776d5295aba1.png" />
          					<p>{{item.lineUpNum ? item.lineUpNum : '0'}}</p>排队
          				</div>
          			</div>
          			<div class="change-price flex align-center" >
                  <span v-if="item.availableGan">{{item.electricityPrice ? item.electricityPrice :'-'}}</span>
                  <span v-else>{{item.stationPrice ? item.stationPrice :'-'}}</span>
                  元起
          			</div>

          		</div>
          	</div>
            <div class="goaddress" v-if="isApp == 1" @click="goUniapp('map',item)">
            	<img src="https://sass.gclme.com/api/file/Image/annex/20220105_461c23a5592f4c118561359af68ba0c8.png" />
            </div>
            <div class="goaddress" v-else @click="chooseMap(item)">
            	<img src="https://sass.gclme.com/api/file/Image/annex/20220105_461c23a5592f4c118561359af68ba0c8.png" />
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>

    </div>
  </div>
</template>
<script type="text/javascript">
// import AMapLoader from '@amap/amap-jsapi-loader';
import { Toast } from 'vant';
export default {
  name: 'xiexinmapwebview',
  data() {
    return {
      map : null,
      AMap : null,
      AMapUI : null,
      token : null,
      baseurl : null,
      stationAllList: [], // 所有的站点列表
      changeStationList : [], // 换电站列表
      pileStationList : [], // 充电站列表
      stationCovers: [],  // 站点集合
      layer : null,   // 点标记
      actionAdress : {},   // 地址
      location : [116.379028, 39.865042],  // 定位
      driving : null,  // 规划的路线
      objectMarkerList : null,   // markerList对象
      licensePlate : null,  // 车牌号码
      carList : [],  // 附近车辆列表
      // 搜索相关
      searchValue: '',
      searchList: [], // 搜索结果页
      isGetList: false,
      longitude: null, //经度
      latitude: null, //纬度
      sheetShow: false,
      clientType: '',
      appId: '',
      actions: [
        { id:1, name: '高德地图' },
        { id:2, name: '百度地图' },
        { id:3, name: '腾讯地图' },
      ],
      shooseSearchItem : null,   // 搜索选中的对象
      isApp : 1,
       stationTypes:'', // 过滤数据
       locations:'',
       city:'',
       isDefault:''
    }
  },
  computed:{
    activeIndex(){
      return this.stationAllList.filter((item)=>{
        return item.businessStatus != 6
      })
    }
  },
  created() {
    let _this = this;
    document.title = "站点地图"
    this.licensePlate = this.$route.query && this.$route.query.licensePlate ? this.$route.query.licensePlate : null;
    this.token=this.$route.query.token ? this.$route.query.token : "bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIxODEwMDUiLCJzY29wZSI6WyJhbGwiXSwic2luZ2xlTG9naW4iOiIyIiwiZXhwIjoxNjYxNDUxNzkwLCJhdXRob3JpdGllcyI6WyJhYSJdLCJqdGkiOiJlZTdkZjA3ZS0wNDc2LTQ2YWQtODA5OS02MWQyNmY1YWUzMTEiLCJjbGllbnRfaWQiOiJhZG1pbiIsInRva2VuIjoiZ2NsbG9naW5fdG9rZW5fOWUxNmExYjAyYzgxNGI3NTg2MWM3NTAyY2JmZDNiYzEifQ.O7gcJ2YvMvIhkEDPEOB1eWBw-ucK3hU380yFiWtfll-tJCJNtO8L_S4oKQL3cyRBsOPpUtdpot5GTZtVs3JOeSsKA_gV3ll9npKaUiOc2PGojzEmYXwJNrJzDRjNMb721sgESoYobZWc6ilCZG5r0EVhbRhiwg3-l6wQLe1_QP60Grf4SQ1a-Jlg7iMp7jdS_sivC0i80E_PibTfpoIv_hPdEfXoQe7DJcE0BRNpdcke0pN7dG85iI86lXY6m5E02tyvclivnj549Rg7vuRL351cnRILLnrZWxImXNGErsya1ZNWSeaMVbz77FwneSYvvk2VDIcdOU7mBVu9dyqvIg";
    this.location=this.$route.query.location ? this.$route.query.location.split(",") : [116.379028, 39.865042];
    // 'bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIxODcwMTMxODIwNyIsInNjb3BlIjpbImFsbCJdLCJleHAiOjE2NTczMDM2MTksImF1dGhvcml0aWVzIjpbImFhIl0sImp0aSI6ImI3OTZmZGVlLWZlZjctNDk3MS1hMDA2LTQ0OGZhMDFlOGJjMyIsImNsaWVudF9pZCI6ImFkbWluIiwidG9rZW4iOiJnY2xsb2dpbl90b2tlbl8zYzI1NmIyMGQxZGI0ZTczYjJmNDExZmFmNGU1YTA5YyJ9.DA8NNwAvraJMQYg0J23T1xNNhRqxj_--ZFpEIQEsDldIbBYt6H3Q6jdgJ2jg8YRaQnpCHjCwEjjniSil0jZM79a_lAZkdj1QPDvEQgt8FFLmjr86m3gxBF4ePQz5jWdN4F7AMh8aBZ3wvOc3D5KMudQJ1JQCga_cUl1-1VtUACK_bu5uYHW99w4ejwauVknPWiv1xbjwIDDM0i1R8qdm1ZAvQZo3uNjZ9EewRRoUmMasn0rd4mXA_vComgVW4-PJoP4FopT5TQIIUria-De_Xb3l7KZfsZttyW16Un3gw7LI717NNoE_jLafTjaR2veIDgLj4B4JnxAC2KNXrXBABg';
    this.baseurl=this.$route.query.baseurl ? this.$route.query.baseurl : 'https://sass.gclme.com';
    this.isApp=this.$route.query.isApp ? this.$route.query.isApp : 1;
    this.clientType = this.$route.query.clientType
    this.appId = this.$route.query.appId
    console.log(this.clientType, this.appId, '============clientType&appId')
    window._AMapSecurityConfig = {
      securityJsCode: '5d52d08f659664f824f5021ef237b1c0'
    }
    var elem = document.createElement("script");
    elem.src = "https://webapi.amap.com/maps?v=2.0&key=3c323c18d7f2d237ba10b4f06c5a1648&plugin=AMap.Driving,AMap.Geolocation";
    document.body.appendChild(elem);
    elem.onload = elem.onreadystatechange = function () {
        if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
          var elemUI = document.createElement("script");
          elemUI.src = "https://webapi.amap.com/ui/1.1/main.js";
          document.body.appendChild(elemUI);
          elemUI.onload = elemUI.onreadystatechange = function () {
              if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {

                _this.initMap();
              }
          }
        }
    }
  },
  watch: {
    searchValue: {
      immediate: true,
      handler() {
        this.isGetList = false
      }
    },
  },
  methods: {
    // H5返回
    goBack(){
      window.history.go(-1)
    },
      goUniapp (page,item){
        let _this = this;
        let data = {}
        if(page == 'detail'){
          // 判断是充电桩还是换电站
          if(item.availableGan) {
            //充电站
            data = {
              page : "rechargedetail",
              item : item
            }
          } else {
            //换电站
            data = {
              page : "detail",
              item : item
            }
          }

        }else if(page == 'map'){
          data = {
            page : "map",
            item : item,
            actionAdress : this.actionAdress
          }
        }
        uni.postMessage({
            data: {
                action: data
            }
        });
      },
      initMap(){
        let _this = this;
        Toast.loading({
          message: '加载地图中...',
          forbidClick: true,
          duration : 0
        });
       this.AMap = AMap;
       this.AMapUI = AMapUI;
       this.map = new AMap.Map('container', {
             viewMode:"3D",    //是否为3D地图模式
             center: [116.469881, 39.993599],//初始化地图中心点位置
       });
       this.AMapUI.loadUI(['misc/MarkerList'], function(MarkerList) {
           //启动页面
           _this.objectMarkerList = MarkerList
           _this.objectMarkerList = MarkerList
           _this.locations= _this.getQueryVariable('locations'),
            _this.city=_this.getQueryVariable('city'),
            _this.isDefault=_this.getQueryVariable('isDefault'),

            _this.getStatonList();

       })
        // AMapLoader.load({
        //     key:"3c323c18d7f2d237ba10b4f06c5a1648",  // 申请好的Web端开发者Key，首次调用 load 时必填
        //     version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        //     plugins:['AMap.Driving','AMap.Geolocation'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        // }).then((AMap)=>{
        //     this.AMap = AMap;
        //     this.AMapUI = AMapUI;
        //     this.map = new AMap.Map("container",{  //设置地图容器id
        //         viewMode:"3D",    //是否为3D地图模式
        //         center: [116.469881, 39.993599],//初始化地图中心点位置
        //     });
        //     // this.mapLocation();
        //     this.AMapUI.loadUI(['misc/MarkerList'], function(MarkerList) {
        //         //启动页面
        //         _this.objectMarkerList = MarkerList
        //         _this.getStatonList();
        //     })
        // }).catch(e=>{
        //     console.log('AMapErrol',e);
        // })
      },
      setIcon (){
        var icon = {
           // 图标类型，现阶段只支持 image 类型
           type: 'image',
           // 图片 url
           image: 'https://sass.gclme.com/api/file/Image/annex/20220711_e9f95a0d37eb4c8986d305162e1dee91.png',
           // 图片尺寸
           size: [64, 30],
           // 图片相对 position 的锚点，默认为 bottom-center
           anchor: 'center',
        }
        return icon;
      },
      // 获取换电站列表
      async getStatonList(){
        let _this = this;
        Toast.loading({
          message: '正在获取您附近的站点...',
          forbidClick: true,
          duration : 0
        });
        var header ={
          'X-Access-Token': ''
        }
        if(this.token){
          header ={
            'authorization': this.token
          }
        }
        var params = {}
        if(_this.licensePlate){
          params = {
            'pageSize': 10,
            'currentPage': 1,
            longitude: _this.location[0],
            latitude: _this.location[1],
            comprehensive: 1,
            licensePlate: _this.licensePlate,
            // onlyShowOpeningStation : 1,
            location: _this.locations!=false ?  decodeURIComponent(decodeURIComponent(_this.locations)) : '',
            city:_this.city!=false?  decodeURIComponent( decodeURIComponent(_this.city)): '',
            isDefault:_this.isDefault,
           }
        }else{
          params = {
            'pageSize': 10,
            'currentPage': 1,
            longitude: _this.location[0],
            latitude: _this.location[1],
            comprehensive: 1,
            // onlyShowOpeningStation : 1,
            location: _this.locations!=false ?  decodeURIComponent(decodeURIComponent(_this.locations)) :''  ,
            city:_this.city!=false?  decodeURIComponent( decodeURIComponent(_this.city)):'' ,
            isDefault:_this.isDefault,
          }
        }

        try {
          const { data } = await this.$http({
            method : 'get',
            url : `${this.baseurl}/api/changepower/changePowerList/gcl`,
            headers:header,
            params : params,
          });

          console.log(JSON.stringify(data),"changeStationList")
          console.log( decodeURIComponent(decodeURIComponent(_this.locations)),'解码');
          this.changeStationList = data && data.data && data.data.list ? data.data.list : [];
          Toast.clear();
          this.getPileStationList()
          // this.stationAllList.forEach(item => { // foreach循环接口返回的值
          // 	_this.stationCovers.push({ //往里面添加循环数据
          //     id: item.id,
          //     name: item.stationName,
          //     position: [item.longitude,item.latitude],
          //     zooms: [10, 20],
          //     opacity: 1,
          //     zIndex: 16,
          //     icon:_this.setIcon(item),
          //     text: {
          //         // content: '可换' + (item.replaceableBattery?item.replaceableBattery:'0') + ',排队' + (item.lineUpNum?item.lineUpNum:'0'),
          //         content: `<div>1111</div>`,
          //         direction: 'top',
          //         offset: [0, 0],
          //         style: {
          //           fontSize: 12,
          //           fontWeight: 'normal',
          //           fillColor: '#0A2463',
          //           strokeColor: '#0A2463',
          //           strokeWidth: 2,
          //           padding: [10, 20 ,10, 20],
          //           backgroundColor: "#fff"
          //         }
          //     }
          // 	})
          // })
          // map.clearMap();  // 清除地图覆盖物
          // _this.setIcon(item)
//           _this.stationAllList.forEach(function(item) {
// // '<div class="top-box">30分钟,10km<div class="down-icon"></div></div>' +
//               new _this.AMap.Marker({
//                   content : '<div class="map-box" >' +

//                               '<div class="bottom-box">'+
//                                 '<img class="bottom-icon" onclick="mapClick(' + item + ')"  src="https://sass.gclme.com/api/file/Image/annex/20220711_e9f95a0d37eb4c8986d305162e1dee91.png">' +
//                                 '<div class="bottom-info">可换' + item.replaceableBattery + ',排队' + item.lineUpNum +
//                                 '</div>'+
//                               '</div>'+
//                             '</div>',
//                   map: _this.map,
//                   icon: 'https://sass.gclme.com/api/file/Image/annex/20220711_e9f95a0d37eb4c8986d305162e1dee91.png',
//                   position: [item.longitude, item.latitude],
//                   offset: new _this.AMap.Pixel(-13, -30)
//               });
//           });
        } catch (err) {
          console.log('err',err)
          Toast.clear();
          this.getPileStationList()
        }
      },
      getQueryVariable(variable){
          var query = window.location.href.split('xiexinmapwebview?')[1];
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
          }
          return(false);
      },
      // 获取充电站列表
      async getPileStationList(){
        let _this = this;
        let locationArr = this.getQueryVariable('location')
        console.log(locationArr)
        let longitude = locationArr ? locationArr.split(',')[0] : ''
        let latitude = locationArr ? locationArr.split(',')[1] : ''
        var header ={
          'X-Access-Token': ''
        }
        if(this.token){
          header ={
            'authorization': this.token
          }
        }
        Toast.loading({
          message: '正在获取您附近的站点...',
          forbidClick: true,
          duration : 0
        });
        try {
          console.log('this.baseurl========', this.baseurl)
          const { data } = await this.$http({
            method : 'get',
            url : `${this.baseurl}/api/station/stationData/pileList`,
            headers: header,
            params: {
              "tenant": "gcl",
              "longitude": longitude,
              "latitude": latitude,
              "city":_this.city!=false?  decodeURIComponent( decodeURIComponent(_this.city)): '',
              clientType: this.clientType,
              appId: this.appId,
              // 'pageSize': 10,
              // 'currentPage': 1,
            }
          });
          this.pileStationList = data && data.data ? data.data : [];
          console.log(this.pileStationList,"pileStationList")
          Toast.clear();
          this.initPage(this.objectMarkerList)
        } catch (err) {
          console.log('getPileStationList err',err)
          Toast.clear();
          this.initPage(this.objectMarkerList)
        }
      },
      initPage(MarkerList) {
        console.log('进来');
        let isfilt= this.getQueryVariable('stationTypes')
        this.stationAllList = this.changeStationList.concat(this.pileStationList);
          if(isfilt==1){

            this.stationAllList=  this.pileStationList
            console.log('等yu111', this.stationAllList);
          }else if(isfilt==0){
            this.stationAllList=this.changeStationList
            console.log('等yu000', this.stationAllList);
          }
          console.log(this.changeStationList,'换电数据',this.pileStationList,'充电数据');
          console.log(isfilt,'这是传来的状态');

        // this.stationAllList = this.changeStationList.concat(this.pileStationList);
        if(this.stationAllList.length > 0){
          let _this = this;
          Toast.loading({
            message: '正在安置您附近的站点...',
            forbidClick: true,
            duration : 0
          });
          //创建一个实例
          var markerList = new MarkerList({
              map: this.map, //关联的map对象
              getDataId: function(dataItem, index) {
                  //返回数据项的Id
                  return dataItem.id;
              },
              getPosition: function(dataItem) {
                  //返回数据项的经纬度，AMap.LngLat实例或者经纬度数组
                  return dataItem.position;
              },
              getMarker: function(dataItem, context, recycledMarker) {
                var content;
                if(dataItem.availableGan){
                  content = '<div class="map-box" >' +
                              '<div class="bottom-box">'+
                                '<img class="bottom-icon" src="https://sass.gclme.com/api/file/Image/annex/20220719_1e4070d31cd94e1baf66410461a7c573.png">' +
                                '<div class="bottom-info">可充' + dataItem.availableGan +
                                '</div>'+
                              '</div>'+
                            '</div>'
                }else{
                  content = '<div class="map-box" >' +
                              '<div class="bottom-box">'+
                                '<img class="bottom-icon" src="https://sass.gclme.com/api/file/Image/annex/20220711_e9f95a0d37eb4c8986d305162e1dee91.png">' +
                                '<div class="bottom-info">可换' + (dataItem.replaceableBattery ? dataItem.replaceableBattery : 0) + ',排队' + (dataItem.lineUpNum ? dataItem.lineUpNum : 0) +
                                '</div>'+
                              '</div>'+
                            '</div>'
                }
                 var label = {
                      offset: new AMap.Pixel(16, 18),
                      content: content
                  };

                  if (recycledMarker) {
                      //存在可回收利用的marker,直接setLabel返回
                      recycledMarker.setLabel(label);
                      return recycledMarker;
                  }
                  //返回一个新的Marker
                  return new AMap.Marker({
                      // label: label,
                      content: content
                  });
              },

              getInfoWindow: function(dataItem, context, recycledInfoWindow) {
                console.log('jin 绘制路线',dataItem);
                _this.mapDriving(dataItem).then((res) => {
                  console.log('绘制路线返回数据',res);
                  dataItem = res
                  var timeStr = 0;
                  if(dataItem.drivingTime/60 > 60){
                    timeStr = parseInt(dataItem.drivingTime/3600) + '小时' + parseInt(('0.' + dataItem.drivingTime%3600)  * 60) + '分钟'
                  }else{
                    timeStr = (dataItem.drivingTime/60).toFixed(2) + '分钟'
                  }
                  var topBoxDome = document.getElementsByClassName("top-box");
                  topBoxDome[0].innerHTML = timeStr + "," + (dataItem.drivingDistance/1000).toFixed(2) + 'km'
                })
                // <%- dataItem.drivingTime %>分钟,<%- dataItem.desc %>km<div class="down-icon"></div>
                  var tpl = '<div class="top-box"></div>';
                  //MarkerList.utils.template支持underscore语法的模板
                  var content = markerList.utils.template(tpl, {
                      dataItem: dataItem,
                      dataIndex: context.index
                  });
                  if (recycledInfoWindow) {
                      //存在可回收利用的infoWindow, 直接setContent返回
                      recycledInfoWindow.setContent(content);
                      return recycledInfoWindow;
                  }
                  //返回一个新的InfoWindow
                  return new AMap.InfoWindow({
                      offset: new AMap.Pixel(0, -23),
                      content: content
                  });
              },

          });
          //监听选中改变
          markerList.on('selectedChanged', function(event, info) {

          });

          //监听Marker和ListElement上的点击，详见markerEvents，listElementEvents
          markerList.on('markerClick listElementClick', function(event, record) {
            console.log(event, record)
          });

          //构建数据源，数据项本身没有格式要求，但需要支持getDataId和getPosition
          var uniqueList = [];
          for (var i = 0; i < this.stationAllList.length; i++) {
            var found = false;
            for (var j = 0; j < uniqueList.length; j++) {
              if (this.stationAllList[i].id === uniqueList[j].id) {
                found = true;
                break;
              }
            }
            if (!found) {
              uniqueList.push(this.stationAllList[i]);
            }
          }

          // 将去重后的结果赋值回原数组
          this.stationAllList = uniqueList;



          this.stationAllList.forEach(function(item) {
              item.position = [item.longitude, item.latitude]
          });

          let arr2 = []
          this.stationAllList.forEach(function(item) {
            if(item.position && item.position[0] && item.position[1]) {
              arr2.push(item)
            }
          })
          this.stationAllList = arr2
          console.log( this.stationAllList,'过滤的数据');

          //绘制数据源，Let's go!
          markerList.render(this.stationAllList);

          markerList.selectByDataId(this.stationAllList[0].id)

          this.markerList = markerList;
          Toast.clear();
          this.getNearbyCarsList(this.stationAllList[0])   // 获取站点附近的车辆
          //清除数据
          //markerList.render([]);
        }else{
          Toast.fail('您附近没有站点!');
        }
      },
      // 获取站附近车辆
      getNearbyCarsList(item){
        let _this = this;
        var header ={
          'X-Access-Token': ''
        }
        if(this.token){
          header ={
            'authorization': this.token
          }
        }
        this.$http({
          method : 'get',
          url : `${this.baseurl}/api/changepower/changePowerList/nearbyCars/gcl`,
          headers:header,
          params:{
            location : item.position.join(",")   // '114.13511,38.40472'
          }
        }).then(({ data }) => {
          this.carList = data && data.data ? data.data : [];
          this.carPage(item)
        })
        .catch(err=>{

        });
      },
      carPage(childrenItem) {
          //创建一个实例
          var carMarkerList = new this.objectMarkerList({
              map: this.map, //关联的map对象

              getDataId: function(dataItem, index) {

                  //返回数据项的Id
                  console.log(dataItem,'dataItem')
                  return dataItem.id;
              },
              getPosition: function(dataItem) {
                  //返回数据项的经纬度，AMap.LngLat实例或者经纬度数组
                  return dataItem.position;
              },
              getMarker: function(dataItem, context, recycledMarker) {
                //返回一个新的Marker
                // 乗用车
                if(dataItem.type == "23f33c69bf7349cca5df3db83000c76a"){
                  if(parseInt(context.index%2) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate45" src="https://sass.gclme.com/api/file/Image/annex/20220715_ea44ae82dbc942e19ef29bd9cb5fa0fd.png">'
                    });
                  }else if(parseInt(context.index%3) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate90" src="https://sass.gclme.com/api/file/Image/annex/20220715_ea44ae82dbc942e19ef29bd9cb5fa0fd.png">'
                    });
                  }else if(parseInt(context.index%5) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate135" src="https://sass.gclme.com/api/file/Image/annex/20220715_ea44ae82dbc942e19ef29bd9cb5fa0fd.png">'
                    });
                  }else if(parseInt(context.index%7) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate180" src="https://sass.gclme.com/api/file/Image/annex/20220715_ea44ae82dbc942e19ef29bd9cb5fa0fd.png">'
                    });
                  }else if(parseInt(context.index%9) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate225" src="https://sass.gclme.com/api/file/Image/annex/20220715_ea44ae82dbc942e19ef29bd9cb5fa0fd.png">'
                    });
                  }else{
                    return new AMap.Marker({
                        content : '<img class="car-icon" src="https://sass.gclme.com/api/file/Image/annex/20220715_ea44ae82dbc942e19ef29bd9cb5fa0fd.png">'
                    });
                  }
                }else {
                  if(parseInt(context.index%2) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate45" src="https://sass.gclme.com/api/file/Image/annex/20220721_8b2c6a9139d0457188516fc863f5e39b.png">'
                    });
                  }else if(parseInt(context.index%3) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate90" src="https://sass.gclme.com/api/file/Image/annex/20220721_8b2c6a9139d0457188516fc863f5e39b.png">'
                    });
                  }else if(parseInt(context.index%5) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate135" src="https://sass.gclme.com/api/file/Image/annex/20220721_8b2c6a9139d0457188516fc863f5e39b.png">'
                    });
                  }else if(parseInt(context.index%7) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate180" src="https://sass.gclme.com/api/file/Image/annex/20220721_8b2c6a9139d0457188516fc863f5e39b.png">'
                    });
                  }else if(parseInt(context.index%9) == 0){
                    return new AMap.Marker({
                        content : '<img class="car-icon rotate225" src="https://sass.gclme.com/api/file/Image/annex/20220721_8b2c6a9139d0457188516fc863f5e39b.png">'
                    });
                  }else{
                    return new AMap.Marker({
                        content : '<img class="car-icon" src="https://sass.gclme.com/api/file/Image/annex/20220721_8b2c6a9139d0457188516fc863f5e39b.png">'
                    });
                  }
                }
              },

          });
          //构建数据源，数据项本身没有格式要求，但需要支持getDataId和getPosition
          this.carList.forEach(function(item) {
              item.position = [item.longitude, item.latitude]
          });
          //绘制数据源，Let's go!
          carMarkerList.render(this.carList);
          this.carMarkerList = carMarkerList;
      },
      // 定位
      // mapLocation(){
      //   var location,
      //       _this = this;
      //   Toast.loading({
      //     message: '正在获取您的位置...',
      //     forbidClick: true,
      //     duration : 0
      //   });
      //   location = new this.AMap.Geolocation({
      //     // 是否使用高精度定位，默认：true
      //     enableHighAccuracy: true
      //   })
      //   location.getCurrentPosition(function(status,result){
      //     if(status=='complete'){
      //       _this.location = result.position.toString().split(",");
      //     }

      //   });
      // },
      // 绘制路线
      mapDriving(item){
        console.log('近绘制路线');
        var _this = this;
        return new Promise(function(res,rej){
          if(_this.driving&&_this.driving.render){
            _this.driving.render.clear();
          }
          _this.driving = new _this.AMap.Driving({
            policy: AMap.DrivingPolicy.LEAST_TIME,//速度最快的策略
            map: _this.map,
            hideMarkers : true,
            autoFitView: true //自动调整地图视野使绘制的路线处于视口的可见范围
          })
          _this.actionAdress = {
            planDeliveryPosition : _this.location,
            planCollectPosition : item.position,
          };

          _this.driving.search(_this.location,item.position, (status, result) => {
            if (status === 'complete') {
              item.drivingDistance = result.routes[0].distance;
              item.drivingTime = result.routes[0].time;
              res(item)
            } else {
              rej(result)
              console.log('Driving',result)
            }
          })
        })
      },
      swiperChange(e){
        this.markerList.selectByDataId(this.stationAllList[e].id);
        if(this.carMarkerList){
          this.carMarkerList.clearData();
        }
        this.getNearbyCarsList(this.stationAllList[e])
      },
      // 搜索相关功能
      chooseMap(item){
        let _this = this;
        console.log("1")
        if(this.isApp == 3 || this.isApp == 4){
          console.log("2")
        //打开地图，商家位置导航
            var mini=false;
            console.log(wx)
            let itemstationName = item.stationName ? item.stationName : item.name
            if(_this.isApp == 3){
              wx.miniProgram.getEnv(function(res){
                console.log(res)
                  if (res.miniprogram){
                    console.log(res.miniprogram)

                    wx.miniProgram.navigateTo({url: "/package/pages/mapwebview/locationMapwebview?latitude="+ item.latitude +"&longitude="+ item.longitude +"&address="+ item.detailedAddress + "&stationName=" + itemstationName});
                  }
              });
              console.log("3")
            }else{
              console.log("4")
              wx.miniProgram.navigateTo({
                url: "/pages/electro_map/electro_map?latitude="+ item.latitude +"&longitude="+ item.longitude +"&address="+ item.detailedAddress + "&stationName=" + itemstationName,
                success: function(res) {
                  console.log('navigateTo success:', res)
                },
                fail: function(res) {
                  console.log('navigateTo fail:', res)
                },
                complete: function(res) {
                  console.log('navigateTo complete:', res)
                }
              });
            }
            mini=true;
        }else{
          console.log("5")
          this.shooseSearchItem = item;
          this.sheetShow = true;
        }
        // console.log(wx)
      },
      onSelect(item){
        this.guide(item.id, this.shooseSearchItem)
      },
      guide(signMap, item) {
        if (item.stationName && item.stationName != '') {
          //景点位置position.name 景点经纬度lng lat
          var lng = item.longitude;
          var lat = item.latitude;
          var u = navigator.userAgent, app = navigator.appVersion;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          var lng = this.shooseSearchItem.longitude;
          var lat = this.shooseSearchItem.latitude;
          if (signMap == 1) {
            // 高德地图
            if (isAndroid) {
              window.location.href =
                "androidamap://viewMap?sourceApplication=appname&poiname=" + item
                .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
              //判断是否跳转
              setTimeout(function() {
                let hidden = window.document.hidden || window.document
                  .mozHidden || window.document.msHidden || window.document
                  .webkitHidden
                if (typeof hidden == "undefined" || hidden == false) {
                  //调用高德地图
                  window.location.href =
                    "https://uri.amap.com/marker?position=" + lng + "," +
                    lat + "&name=" + item.stationName;
                }
              }, 2000);
            } else {
              window.location.href =
                "iosamap://viewMap?sourceApplication=appname&poiname=" + item
                .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
              //判断是否跳转
              setTimeout(function() {
                let hidden = window.document.hidden || window.document
                  .mozHidden || window.document.msHidden || window.document
                  .webkitHidden
                if (typeof hidden == "undefined" || hidden == false) {
                  //调用高德地图
                  window.location.href =
                    "https://uri.amap.com/marker?position=" + lng + "," +
                    lat + "&name=" + item.stationName ;
                }
              }, 2000);
            }
          } else if (signMap == 2) {
            // 百度地图
            if (isAndroid) {
              let d = new Date();
              let t0 = d.getTime();
              window.location.href =
                "androidamap://viewMap?sourceApplication=appname&poiname=" + item
                .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
              //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
              var delay = setInterval(function() {
                var d = new Date();
                var t1 = d.getTime();
                if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                  window.location.href =
                    "http://api.map.baidu.com/marker?location=" + lat +
                    "," + lng + "&title=" + item.stationName +
                    "&content=站点&output=html&src=webapp.baidu.openAPIdemo";
                }
                if (t1 - t0 >= 3000) {
                  clearInterval(delay);
                }
              }, 1000);
            } else {
              let d = new Date();
              let t0 = d.getTime();
              window.location.href =
                "iosamap://viewMap?sourceApplication=appname&poiname=" + item
                .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
              //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
              let delay = setInterval(function() {
                var d = new Date();
                var t1 = d.getTime();
                if (t1 - t0 < 3000 && t1 - t0 > 2000) {
                  window.location.href =
                    "http://api.map.baidu.com/marker?location=" + lat +
                    "," + lng + "&title=" + item.stationName +
                    "&content=站点&output=html&src=webapp.baidu.openAPIdemo";
                }
                if (t1 - t0 >= 3000) {
                  clearInterval(delay);
                }
              }, 1000);
            }
          } else {
            // 腾讯地图
            if (isAndroid) {
              window.location.href =
                "androidamap://viewMap?sourceApplication=appname&poiname=" + item
                .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
              //判断是否跳转
              setTimeout(function() {
                let hidden = window.document.hidden || window.document
                  .mozHidden || window.document.msHidden || window.document
                  .webkitHidden
                if (typeof hidden == "undefined" || hidden == false) {
                  //调用腾讯地图
                  window.location.href =
                    `https://apis.map.qq.com/uri/v1/marker?marker=coord:(${lat},${lng})&addr:${item.stationName}`
                }
              }, 2000);
            } else {
              window.location.href =
                "iosamap://viewMap?sourceApplication=appname&poiname=" + item
                .stationName + "&lat=" + lat + "&lon=" + lng + "&dev=0";
              //判断是否跳转
              setTimeout(function() {
                let hidden = window.document.hidden || window.document
                  .mozHidden || window.document.msHidden || window.document
                  .webkitHidden
                if (typeof hidden == "undefined" || hidden == false) {
                  //调用高德地图
                  window.location.href =
                    `https://apis.map.qq.com/uri/v1/marker?marker=coord:(${lat},${lng})&addr:${item.stationName}`
                }
              }, 2000);
            }
          }
        } else {
          Toast.fail('未获取到该站点位置...');
        }
      },
      InputBlur(e) {
        this.searchValue = e && e.currentTarget && e.currentTarget.value
        if (this.searchValue != '') {
          this.getList();
        }
      },
      inputConfirm(e) {
        this.searchValue = e && e.detail && e.detail.value
        if (!this.searchValue) {
          Toast('请输入搜索内容...');
        } else {
          this.getList();
        }
      },
      search(item) {
        if (!this.searchValue) {
          Toast('请输入搜索内容...');
        } else {
          this.getList();
        }
      },
      getList() {
        let _this = this;
        Toast.loading({
          message: '正在搜索...',
          forbidClick: true,
          duration : 0
        });
        console.log('this.baseurl========', this.baseurl)
        let isUrl = window.location.hash.includes('sass.gclme.com');
        let url = `${this.define}/api/station/stationData/pileList`;
        if(!isUrl){
          url = `${this.baseurl}/api/station/stationData/pileList`
        }
        this.$http({
            method: 'get',
            url: url,
            params: {
              'stationName': this.searchValue,
              'onlyShowOpeningStation' : 1,
              clientType: this.clientType,
              appId: this.appId,
            }
          }).then(({
            data
          }) => {
            Toast.clear();
            // console.log('===========', data)
            if(isUrl){
              if (data.data.list.length > 0) {
                this.isGetList = true
                _this.announcement2 = data.data.list
                _this.searchList = [];
                _this.searchList = _this.searchList.concat(_this.announcement2); //追加新数据
              } else {
                this.isGetList = false
                Toast.fail('没有找到店铺哦...');
              }
            }else{
              if (data.data.length > 0) {
                this.isGetList = true
                _this.announcement2 = data.data
                _this.searchList = [];
                _this.searchList = _this.searchList.concat(_this.announcement2); //追加新数据
              } else {
                this.isGetList = false
                Toast.fail('没有找到店铺哦...');
              }
            }

          })
          .catch(err => {
            Toast.clear();
            this.isGetList = false
          });
      },
      // 选择站点
      chooseStation(item){
        this.markerList.selectByDataId(item.id);
        item.position = [item.longitude, item.latitude]
        if(this.carMarkerList){
          this.carMarkerList.clearData();
        }
        this.getNearbyCarsList(item)
        this.isGetList = false
      },
}
}
</script>
<style >
  .xiexinChangePowerMap .map-box{
    font-size: 0.32rem;
    color: #0A2463;
    display:flex;
    flex-direction: column;
    position: relative;
    left: -0.74rem;
    /* top: -0.4rem; */
    top: -1.4rem;
  }
  .xiexinChangePowerMap .top-box{
    white-space: nowrap;
    font-size: 0.32rem;
    color: #0A2463;
    /* position: absolute;
    top:-1.066667rem;
    left:-0.533333rem; */
    height: 0.933333rem;
    border-radius: 0.466667rem;
    padding: 0px 0.4rem;
    display:flex;
    align-items: center;
    background:#fff;
    box-shadow: 0px 0px 16px 0px rgba(10,36,99,0.0800);
  }
  .xiexinChangePowerMap .down-icon{
    width: 0px;
    height: 0px;
    border-left: 0.133333rem solid transparent;
    border-right: 0.133333rem solid transparent;
    border-top: 0.133333rem solid #fff;
    position:absolute;
    left: 50%;
    bottom: -0.133333rem;
    transform: translateX(-50%);
    box-shadow: 0px 0px 16px 0px rgba(10,36,99,0.0800);
  }
  .xiexinChangePowerMap .bottom-box{
    display:flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .xiexinChangePowerMap .bottom-icon{
    width: 1.52rem;
    height: 1.626667rem;
  }
  .xiexinChangePowerMap .bottom-info{
    position: absolute;
    background:#fff;
    left:1rem;
    z-index:-1;
    height: 0.933333rem;
    display:flex;
    align-items: center;
    padding-left:0.533333rem;
    padding-right:0.3rem;
    border-radius: 0px 0.466667rem 0.466667rem 0px;
    white-space: nowrap;
  }
  .xiexinChangePowerMap .amap-info-content{
    padding: 0px;
    overflow: hidden;
    background: none;
    box-shadow: none;
  }
  .xiexinChangePowerMap .amap-info-close{
    display: none;
  }
  .xiexinChangePowerMap .amap-info-contentContainer{
    position: relative;
    top: -0.6rem;
  }
  .xiexinChangePowerMap .amap-marker-label{
    border: none;
    background: none;
  }
  .xiexinChangePowerMap .car-icon{
    height: 1.6rem;
  }
  .xiexinChangePowerMap .selected .bottom-info{
    background: linear-gradient(90deg, #58A3FF 0%, #1980FF 100%);
    color: #fff;
  }
  .xiexinChangePowerMap .rotate45{
    transform: rotate(45deg);
  }
  .xiexinChangePowerMap .rotate90{
    transform: rotate(90deg);
  }
  .xiexinChangePowerMap .rotate135{
    transform: rotate(135deg);
  }
  .xiexinChangePowerMap .rotate180{
    transform: rotate(180deg);
  }
  .xiexinChangePowerMap .rotate225{
    transform: rotate(225deg);
  }
  .xiexinChangePowerMap .rotate270{
    transform: rotate(270deg);
  }
</style>
<style lang="stylus" scoped>
  @import "./mapwebview.scss";
</style>



// WEBPACK FOOTER //
// mapwebview.vue?c86f12f8